import { Module } from '../Module';

export class ScriptLoadingService {

  public static $inject = [
    '$q'
  ];

  constructor(
    private $q: ng.IQService,
  ) { }

  public loadScript(srcUrl: string): ng.IPromise<any> {
    const scriptTag: HTMLScriptElement = document.createElement('script');
    document.body.appendChild(scriptTag);
    const promise = this.$q((resolve: () => void, reject: () => void) => {
      scriptTag.onload = resolve;
      scriptTag.onerror = reject;
    });
    scriptTag.src = srcUrl;

    return promise;
  }

}

Module.instance().service('ScriptLoadingService', ScriptLoadingService);
